import { render } from "./forex-trading.vue?vue&type=template&id=9a144178"
import script from "./forex-trading.vue?vue&type=script&lang=js"
export * from "./forex-trading.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__